/** Ctrl-Enter (not Shift, Alt, or Cmd) while Add or Edit Ledger Entry is open. */
function ledgerSaveAndCloseKey(event) {
  if (!event || event.isComposing || event.repeat) return false;
  if (!event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
    return false;
  }
  return event.key === 'Enter' || event.code === 'NumpadEnter';
}

module.exports = {
  ledgerSaveAndCloseKey,
};
